var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"input":_vm.onInput}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }